import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { isPredictiveRetrosynthesisEnabled } from '@Pages/RetroSynthesis/predictiveUtils';
import store from '@Store';
import { openProjectParametersDialog } from '@Pages/RetroSynthesis/ProjectParametersDialog/action';
import Catalyst from '@Services/Catalyst';

function QuickResultPredictButton({ context, databaseId, feedbacks, resultsCount, queryId }) {
  const transferToRT = () => {
    store.dispatch(openProjectParametersDialog({ rxn: null, databaseId, structure: feedbacks[0].structure }));
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'button:predict synthesis', // v124
    });
  };
  const transferToRTAvailable =
    !resultsCount &&
    context === 'substances' &&
    feedbacks &&
    feedbacks.length === 1 &&
    feedbacks[0].structure &&
    isPredictiveRetrosynthesisEnabled();
  return transferToRTAvailable ? (
    <ButtonWithIcon
      data-e2e="predict-results"
      type="tertiary"
      sprite="ChevronRight"
      iconRight
      className="e2e-predict-results"
      onClick={transferToRT}
      aria-label={`Predict synthesis for ${queryId}`}
      aria-describedby={queryId}>
      Predict synthesis
    </ButtonWithIcon>
  ) : null;
}

QuickResultPredictButton.propTypes = {
  context: PropTypes.string,
  queryId: PropTypes.string,
  databaseId: PropTypes.string,
  feedbacks: PropTypes.array,
  resultsCount: PropTypes.number,
};

export default QuickResultPredictButton;
